import { Injectable } from '@angular/core';
import { Client } from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  emit(arg0: string, id: any) {
    throw new Error('Method not implemented.');
  }

  private serverUrl = environment.webSocketNotificationUrl;
  private notificationClient!: Client;
  private notificationConnected = false;
  private notificationSource = new BehaviorSubject<any | null>(null);
  public notifications$ = this.notificationSource.asObservable();

  private serverChatUrl = environment.webSocketChatUrl;
  private chatClient!: Client;
  private chatConnected = false;
  private chatSource = new BehaviorSubject<any | null>(null);
  public chats$ = this.chatSource.asObservable();



  // private notificationConnectedSource = new Subject<string>(); 
  // public isStompnotificationConnected$ = this.notificationConnectedSource.asObservable();

  connect(userId: string): void {
    if (this.notificationConnected) return;
    const socket = new SockJS(this.serverUrl);

    this.notificationClient = new Client({
      webSocketFactory: () => socket as any,
      reconnectDelay: 5000
    });

    this.notificationClient.onConnect = frame => {
      console.log('✅ STOMP notificationConnected:', frame);
      //this.notificationConnectedSource.next(userId);
      this.notificationConnected = true;
      console.log(`🔌 Subscribing to /user/${userId}/queue/notifications`);
      this.notificationClient.subscribe(`/user/${userId}/queue/notifications`, (message: any) => {
        console.log('📬 Message received:', message.body);
        const payload = JSON.parse(message.body);
        console.log('📩 Notification:', payload);
        this.notificationSource.next(payload);
      });
    };

    this.notificationClient.onStompError = frame => {
      console.error('❌ STOMP Error:', frame);
    };

    this.notificationClient.onWebSocketError = err => {
      console.error('❌ WebSocket Error:', err);
    };

    this.notificationClient.activate();

  }

  connectToChat(userId: string): void {
    if (this.chatConnected) return;
    const socket = new SockJS(this.serverChatUrl);

    this.chatClient = new Client({
      webSocketFactory: () => socket as any,
      reconnectDelay: 5000
    });

    this.chatClient.onConnect = frame => {
      console.log('✅ STOMP chatConnected:', frame);
      //this.chatConnectedSource.next(userId);
      this.chatConnected = true;
      console.log(`🔌 Subscribing to /user/${userId}/queue/messages`);
      this.chatClient.subscribe(`/user/${userId}/queue/messages`, (message: any) => {
        console.log('📬 Message received:', message.body);
        const payload = JSON.parse(message.body);
        console.log('📩 chat:', payload);
        this.chatSource.next(payload);
      });
    };

    this.chatClient.onStompError = frame => {
      console.error('❌ STOMP Error:', frame);
    };

    this.chatClient.onWebSocketError = err => {
      console.error('❌ WebSocket Error:', err);
    };

    this.chatClient.activate();

  }

  sendMessage(fromUserId: number, toUserId: number, content: string) {
    ;
    this.chatClient.publish({
      destination: '/app/chat.send',
      body: JSON.stringify({ fromUserId, toUserId, content }),
    });
  }

  disconnect(): void {
    if (this.notificationClient && this.notificationConnected) {
      this.notificationClient.deactivate();
      this.notificationConnected = false;
      console.log('🔌 DisnotificationConnected');
    }
  }
}
